import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api/dining`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Inyecta el wave_id actual como query param en cada request (menos en /waves).
api.interceptors.request.use((config) => {
  const url = config.url || "";
  if (!url.startsWith("/waves")) {
    const wid = localStorage.getItem("dining_current_wave_id");
    if (wid) {
      config.params = { ...(config.params || {}), wave_id: wid };
    }
  }
  return config;
});

export const formatEUR = (n) =>
  new Intl.NumberFormat("es-ES", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Intl.DateTimeFormat("es-ES", { day: "2-digit", month: "short", year: "numeric" }).format(new Date(iso));
  } catch {
    return iso;
  }
};

export const STATUS_LABELS = {
  pending: "Pendiente",
  requested: "Solicitada",
  issued: "Emitida",
  paid: "Pagada",
  overdue: "Vencida",
};

export const KIND_LABELS = {
  anticipo: "Anticipo 10%",
  main: "Principal 90%",
  extra: "No-show (excedentes)",
};

export const STATUS_COLORS = {
  pending: "bg-amber-50 text-amber-700 border-amber-200",
  requested: "bg-blue-50 text-blue-700 border-blue-200",
  issued: "bg-violet-50 text-violet-700 border-violet-200",
  paid: "bg-emerald-50 text-emerald-700 border-emerald-200",
  overdue: "bg-red-50 text-red-700 border-red-200",
};
